//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { IUserSession, UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services/services.module'
import { SYSTEM_SERVICE_NAME, SYSTEM_SERVICE_PROVIDER_NAME, SystemService, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $Q_SERVICE_NAME } from '../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'

import { ActionsController } from './actions.controller'
import { ActionsDetailsDirective } from './details/actions-details.directive'
import { ActionService, ACTION_SERVICE_NAME } from '../../services/action'
import { GridService, GRID_SERVICE_NAME } from '../../services/grid'

//#region Asset Imports

import * as TEMPLATE from './actions.tpl.html'
import './actions.scss'

//#endregion

// Consts

const CONTROLER_NAME: string = 'ActionsController'
const DETAILS_DIRECTIVE_NAME: string = 'actionsDetails'
const MODULE_NAME: string = 'simax.actions'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Actions'
const MENU_INDEX: number = 13
const STATE_NAME: string = 'actions'
const STATE_URL: string = '/actions'

// Consts End

// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    $Q_SERVICE_NAME,
    'api',
    'localDictionary',
    SYSTEM_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    ACTION_SERVICE_NAME,
    GRID_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        $q: ng.IQService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        systemService: SystemService,
        userSession: IUserSession,
        actionService: ActionService,
        gridservice: GridService
    ) => new ActionsController(
        $scope,
        $state,
        $timeout,
        $q,
        api,
        localDictionary,
        systemService,
        userSession,
        actionService,
        gridservice,
        ActionService.REFERENCE_TYPE,
        ActionService.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new ActionsDetailsDirective()])

module.config(["$stateProvider", 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {
    userSessionProvider.getLoggedOperatorAsync().then((loggedOperator: OpOperator) => {
        if (loggedOperator.hasPermission(Activity.ACTION_LIST)
            && !loggedOperator.hasPermission(Activity.ACTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActionModule)) {

            systemServiceProvider.registerDetailsComponent({
                key: 'Action_IdAction',
                componentName: DETAILS_DIRECTIVE_NAME
            })

            MenuItem.addMenuItem(
                ConfigHelper.getIconName(ConfigHelper.Icon.ACTIONS),
                'actions',
                MODULE_NAME_LOCALIZATION_TEXT,
                STATE_NAME,
                MENU_INDEX
            )

            $stateProvider.state(STATE_NAME, {
                url: STATE_URL,
                controller: CONTROLER_NAME,
                template: TEMPLATE,
                params: { ids: null }
            })
        }
    })
}])

// Setup End

export default MODULE_NAME